import { useRef } from 'react';
import { useEffect } from 'react';
import { GMPCourseTableConfig } from './data/GMPCourseTableConfig';
import { GMPCourseFormData } from './data/GMPCourseForm.Data';
import FormCreator from '../../components/Forms/FormCreator';
import Buttons from '../../components/ui/button/Buttons';
import MolGrid from '../../components/Grid/MolGrid';
import { useState } from 'react';
import { useGetAllGMPCourseProviderMutation } from '../../app/services/GMPCourseProvider/GMPCoursePoviderApi';
import { encryptAESID, encryptionData } from '../../utils/Encryption';
import { encryptAES } from '../../services/CryptoService';
import { useLazyGetAllDropDownsForMemberDirectoryQuery } from '../../app/services/common/commonApi';
import { setAllDropDownField } from './utils/setFieldParameter';

const GmpCourseApplicationTaskList = () => {
  const molGridRef = useRef();
  const GmpCorseProviderRef = useRef();
  const [formData, setFromData] = useState(GMPCourseFormData);
  const [dataSource, setDataSource] = useState()
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    organisationName: "",
    uENNumber: "",
    startDate: null,
    endDate: null,
  });

  const [getAllGMPCourseProvider, { isSuccess: isgetAllGMPCourseProvider, isLoading: isLoadingCourseProvider, data: getAllGMPCourseProviderDataResponse },] = useGetAllGMPCourseProviderMutation();
  const [getAllDropDowns, { data: allDropDownResponse, isSuccess: isGetAllDropDownSuccess, isFetching: isGetDropDownFetching, isLoading: dropdownListLoading, },] = useLazyGetAllDropDownsForMemberDirectoryQuery()
  useEffect(() => {
    getAllDropDowns();
    getAllGMPCourseProvider(paginationRequest)
  }, [])

  useEffect(() => {
    if (!isLoadingCourseProvider && isgetAllGMPCourseProvider && getAllGMPCourseProviderDataResponse) {
      setPaginationRequest(prev => ({ ...prev, totalCount: getAllGMPCourseProviderDataResponse.totalCount }));
      setDataSource(getAllGMPCourseProviderDataResponse?.itemList);
    }
  }, [isLoadingCourseProvider, isgetAllGMPCourseProvider, getAllGMPCourseProviderDataResponse]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllGMPCourseProvider(updatedPaginationRequest);
  };

  useEffect(() => {
    if (!isGetDropDownFetching && isGetAllDropDownSuccess && allDropDownResponse) {
      setAllDropDownField(allDropDownResponse);
    }
  }, [isGetDropDownFetching, isGetAllDropDownSuccess, allDropDownResponse]);


  const handleSearch = () => {
    if (!GmpCorseProviderRef.current) {
      return;
    }
    const taskListFormData = GmpCorseProviderRef.current.getFormData();
    const updatedPaginationRequest = {
      PageNo: 1,
      PageSize: 20,
      OrganisationName: taskListFormData?.organisationName || "",
      UENNumber: taskListFormData?.uENNumber || "",
      StatusId: taskListFormData?.statusId?.value || null,
      StartDate: taskListFormData?.startDate || null,
      EndDate: taskListFormData?.endDate || null,
      SourceId:taskListFormData?.sourceId?.value || null
    };
    setPaginationRequest(updatedPaginationRequest);
    getAllGMPCourseProvider(updatedPaginationRequest);
  };

  const handleProcessClick = (data) => {
   
    if (data.cpidNumber && data.cpidNumber.startsWith("E")) {
      window.open(`/editCpdEvent/${encryptAESID(data.gmpCourseProviderId)}`)
    }
    else {
      window.open(`/editCourseProvider/${encryptAESID(data.gmpCourseProviderId)}`)
    }

  }

  const actionHandler = {
    Process: handleProcessClick,
  };


const handleClear = ()=>{
  const formData = {...GMPCourseFormData};
  formData.initialState={
      OrganisationName:null,
      UENNumber: null,
      StartDate:null,
      EndDate: null,
      StatusId:null,
      SourceId:null
  }
  let request={
    ...paginationRequest,
      OrganisationName:null,
      UENNumber: null,
      StartDate:null,
      EndDate: null,
      StatusId:null,
      SourceId:null
  }
  setPaginationRequest(prev=>{return{...prev,...request}});
  getAllGMPCourseProvider(request)
  setFromData(formData)
}

  return (
    <div>
      <div className="form-section">
        <div className="row">
          <div className="row col-10">
            {!isGetDropDownFetching&&
            <FormCreator ref={GmpCorseProviderRef} {...formData} />
            }
          </div>
          <div className="btn-sec col-2 mt-auto mb-2 course-search-btn"> 
             <Buttons
              buttonText="Clear"
              buttonTypeClassName="btn success-btn ml-auto mr-0 "
              onClick={handleClear}
            />
            <Buttons
              buttonText="Search"
              buttonTypeClassName="btn success-btn ml-auto mr-0 mt-3"
              onClick={handleSearch}
            />
          </div>
          
        </div>
      </div>
      <div className="mt-4">
        <MolGrid
          ref={molGridRef}
          configuration={GMPCourseTableConfig}
          dataSource={dataSource}
          allowPagination={true}
          isLoading={isLoadingCourseProvider}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onActionChange={actionHandler}
        />
      </div>
    </div>
  )
}

export default GmpCourseApplicationTaskList;